<template>
    <div>
        <div class="collection-title">
            <div style="display: flex; align-items: center">
                <div class="title-line"></div>
                <span class="title-content">盈亏查询</span>
                <span class="deadline-text">截至日期 {{ date }}</span>
            </div>
        </div>

        <div class="filterCriteria">
            <span class="auto-define">时间区间：</span>
            <el-radio-group v-model="tradeTime" size="mini">
                <el-radio-button v-for="type in tradeTimeArr" :key="type.val" :label="type.val">
                    {{ type.text }}
                </el-radio-button>
            </el-radio-group>
            <el-form ref="form" :rules="rules" :model="form">
                <el-form-item label="">
                    <el-date-picker
                        v-model="form.startDate"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyyMMdd"
                        placeholder="请输入开始日期"
                    ></el-date-picker>
                    <span style="margin: 0 10px">至</span>
                    <el-date-picker
                        v-model="form.endDate"
                        type="date"
                        format="yyyy-MM-dd"
                        value-format="yyyyMMdd"
                        placeholder="请输入结束日期"
                    ></el-date-picker>
                    <el-button class="collection-title-btn" v-on:click="queryProfitLoss">
                        确定
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
        <div class="table-container">
            <el-table
                :data="profitLossData"
                class="tab-list-tit"
                border
                :header-cell-style="{ background: 'var(--bg-color-lightest)' }"
                :summary-method="getSummaries"
                show-summary
            >
                <template #empty>
                    <div class="no-funds">
                        <div class="no-funds-box">
                            <p>抱歉：没有找到匹配的数据</p>
                        </div>
                    </div>
                </template>
                <el-table-column prop="fundName" label="基金名称"></el-table-column>
                <el-table-column prop="initialValue" label="期初市值(元)"></el-table-column>
                <el-table-column label="期间投入" align="center">
                    <el-table-column prop="province" label="认/申购"></el-table-column>
                    <el-table-column prop="transferIn" label="转换入"></el-table-column>
                </el-table-column>
                <el-table-column label="期间退出" align="center">
                    <el-table-column prop="transferOut" label="赎回及转出"></el-table-column>
                    <el-table-column prop="dividend" label="现金分红"></el-table-column>
                </el-table-column>

                <el-table-column prop="finalValue" label="期末市值(元)"></el-table-column>
                <el-table-column prop="periodProfit" label="期间收益(元)"></el-table-column>
                <el-table-column prop="profitRate" label="收益率(%)"></el-table-column>
                <el-table-column prop="salesChannel" label="销售渠道"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import mixin from "@/assets/js/mixin";
import fundApi from "@/api/fund";
import format from "date-fns/format";

export default {
    name: "MyCollection",
    components: {},
    mixins: [mixin],
    data() {
        return {
            queryFind: null, // 定时器
            allPage: "0", // 所有数据条数
            pagecount: 10, // 分页条数
            pageoffset: 1, // 起始页
            date: "", // 当前日期
            hasLoad: false, // 是否已经查询数据
            sdxFundInfo: {},
            sdxDialogVisible: false,
            activeIndex: "2",
            form: {
                startDate: "",
                endDate: ""
            },
            rules: {
                startDate: [
                    { type: "date", required: true, message: "请选择开始日期", trigger: "change" }
                ],
                endDate: [
                    { type: "date", required: true, message: "请选择结束日期", trigger: "change" }
                ]
            },
            profitLossData: [
                {
                    fundName: "基金A",
                    initialValue: 10000,
                    purchase: 2000,
                    transferIn: 500,
                    redeem: 1000,
                    transferOut: 300,
                    dividend: 200,
                    finalValue: 11000,
                    periodProfit: 1000,
                    profitRate: 10,
                    salesChannel: "渠道A"
                },
                {
                    fundName: "基金B",
                    initialValue: 8000,
                    purchase: 1500,
                    transferIn: 0,
                    redeem: 800,
                    transferOut: 0,
                    dividend: 100,
                    finalValue: 8700,
                    periodProfit: 700,
                    profitRate: 8.75,
                    salesChannel: "渠道B"
                }
            ],
            tradeTime: "", // 已选择的时间区间
            endDate: "", // 结束时间
            beginDate: "", // 开始时间
            tradeTimeArr: [
                // 时间周期
                { val: "1", text: "近1个月" },
                { val: "2", text: "近1年" },
                { val: "3", text: "自定义" }
            ],
            curSelectDate: []
        };
    },
    watch: {
        // 已选择的时间周期
        tradeTime(val, old) {
            this.curPage = 1;
            this.pageoffset = "1";
            this.allPage = 0;
            this.endDate = this.nowDate;
            const _x = new Date(this.$util.fmtDate(this.nowDate)).getTime();
            if (val === "1") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1);
            } else if (val === "2") {
                this.beginDate = this.$util.getBeginDate(this.nowDate, 1, true);
            } else if (val === "3") {
                this.allPage = 0;
                this.endDate = "";
                this.beginDate = "";
                this.form.startDate = "";
                this.form.endDate = "";
                return;
            }
            console.log(this.beginDate);
            console.log(this.endDate);
            this.form.startDate = this.beginDate;
            this.form.endDate = this.endDate;
            console.log(this.form);
            // this.pageoffset = "1";
            this.doAction();
        }
    },
    created() {
        this.nowDate = format(new Date(), "YYYYMMDD");
    },
    mounted() {
        this.date = this.$util.fmtDate(format(new Date(), "YYYYMMDD"));
        this.tradeTime = "1";
        this.doAction();
    },
    methods: {
        // 获取用户选中时间区间
        dateInterval(val) {
            // convert "YYYY-MM-DD" to "YYYYMMDD"
            this.beginDate = this.$util.isEmpty(val.beginDate)
                ? ""
                : val.beginDate.replace(/-/g, "");
            this.endDate = this.$util.isEmpty(val.endDate) ? "" : val.endDate.replace(/-/g, "");
        },
        // 监听日期选择器
        getDate(val) {
            if (val.length === 2) {
                this.beginDate = val[0];
                this.endDate = val[1];
                console.log(this.beginDate);
                console.log(this.endDate);
            }
        },
        getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = "合计：";
                    return;
                }
                const values = data.map((item) => Number(item[column.property]));
                if (!values.every((value) => isNaN(value))) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return prev + curr;
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] += "";
                } else {
                    sums[index] = "";
                }
            });

            return sums;
        },

        queryProfitLoss() {
            if (!this.form.startDate || !this.form.endDate) {
                this.$message.error("开始日期或结束日期不能为空");
            } else {
                this.doAction();
            }
        },

        // 获取关注基金信息
        async doAction(val, cb) {
            const _this = this;
            const _x = {
                startDate: this.form.startDate,
                endDate: this.form.endDate
            };
            const res = await fundApi.qryCollectFund(_x);
            console.log(123, res);

            if (res.data) {
                this.profitLossData = [];
            }
        }
    }
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/varibles";
.collection-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 15px 0;
    .deadline-text {
        font-size: 14px;
        color: var(--color-text-accent);
        line-height: 25px;
    }
}

.filterCriteria {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .el-form {
        margin-left: 10px;
        display: inline-block;
        .el-form-item {
            margin-bottom: 0;
        }
    }
    .el-radio-button {
        margin-right: 10px;
    }
    :deep(.el-radio-button__inner) {
        border: 0 !important;
    }
}
.table-container {
    :deep(.el-table__empty-block) {
        min-height: 240px;
    }
    :deep(.el-table__footer-wrapper) {
        margin-top: 200px !important; /* 设置合计行的margin-top */
    }
}
.collection-title-btn {
    margin-left: 10px;
    color: var(--color-primary);
    border: 1px solid var(--color-primary);
}
</style>
